import { withLoading, getExpiringLocalStorage } from '@front-activerse/common-components';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import UniversalPlaceholder from '../../Layout/UniversalPlaceholder';

const SavePaymentContainer = ({ savePayment, userData, shoppingCartToken, pathPaymentMethods }) => {
  const navigate = useNavigate();
  const handleSavePayment = async () => {
    const request = {
      productId: +localStorage.getItem('shopppingCartProductId'),
      source: getExpiringLocalStorage('saleSource'),
      saleShoppingId: 1,
      shoppingCartToken,
      email: userData.email,
      promoCode: getExpiringLocalStorage('promoCode'),
    };

    const response = await savePayment(request);

    if (response.data.sale.savePayment.__typename === 'Payment') {
      const paymentToken = response.data.sale.savePayment.token;
      navigate(pathPaymentMethods.replace(':token', paymentToken));
    }
  };

  useEffect(() => {
    handleSavePayment();
  }, []);
  return null;
};
const Placeholder = () => <UniversalPlaceholder simpleLayout fullHeightMinusHeader />;

export default withLoading(SavePaymentContainer, Placeholder);
